export const UPDATE_INSTALL = 'UPDATE_INSTALL'

export const updateInstall = payload => ({
  type: UPDATE_INSTALL,
  payload,
})
